import uniqueId from 'lodash/uniqueId';
import { domain } from 'modules/data';

import { NetSuiteExpenseLineExpanded } from '../../data/types';
import {
    setCurrencyPrecision,
    updateLineOnAmountChange,
    updateLineOnGrossAmountChange,
    updateLineOnTaxCodeChange,
} from '../../helpers';
import { checkExpenseLineIsEmpty } from '../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';

export const generateExpenseLineId = () => uniqueId('netSuiteExpenseLine-');

export const expandExpenseLine = (item: domain.NetSuiteExpenseLine): NetSuiteExpenseLineExpanded => {
    return {
        ...item,
        id: generateExpenseLineId(),
        isEmpty: checkExpenseLineIsEmpty(item),
    };
};

export const createNewExpenseLine = (lineNumber = 0): NetSuiteExpenseLineExpanded => {
    return {
        id: generateExpenseLineId(),
        amount: null,
        class: null,
        customer: null,
        projectTask: null,
        department: null,
        grossAmount: null,
        isBillable: false,
        lineNumber,
        location: null,
        taxAmount: null,
        taxCode: null,
        taxRate: null,
        account: null,
        category: null,
        memo: null,
        amortizationSchedule: null,
        amortizationStartDate: null,
        amortizationEndDate: null,
        amortizationResidual: null,
        isEmpty: true,
    };
};

export const getUpdatedExpenseLine = <K extends keyof NetSuiteExpenseLineExpanded>(
    line: NetSuiteExpenseLineExpanded,
    key: K,
    value: NetSuiteExpenseLineExpanded[K],
    currencyPrecision: number
) => {
    let newLine = {
        ...line,
        [key]: value,
    };

    switch (key) {
        case 'amount': {
            newLine = updateLineOnAmountChange(line, newLine.amount, currencyPrecision);

            break;
        }

        case 'grossAmount': {
            newLine = updateLineOnGrossAmountChange(line, newLine.grossAmount, currencyPrecision);

            break;
        }

        case 'taxCode': {
            newLine = updateLineOnTaxCodeChange(line, newLine.taxCode, currencyPrecision);

            break;
        }

        case 'amortizationResidual': {
            newLine.amortizationResidual = setCurrencyPrecision(value, currencyPrecision);

            break;
        }

        case 'customer': {
            newLine.projectTask = null;

            break;
        }

        default: {
            break;
        }
    }

    newLine.isEmpty = checkExpenseLineIsEmpty(newLine);

    return newLine;
};
